<template>
    <div>
        <div class="main-button-bar">
            <el-row>
                <el-button type="primary" size="small" @click="showAddDialog(null)">新增报销</el-button>
            </el-row>

            <el-row class="search-row">
                <el-select v-model="params.status" clearable placeholder="选择报销状态" class="search-item">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-date-picker
                    type="date"
                    placeholder="开始报销日期"
                    v-model="params.timeStart"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="截止报销日期"
                    v-model="params.timeEnd"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

            </el-row>

            <el-row class="search-row">
                <el-input v-model="params.id" placeholder="报销单号" class="search-item"></el-input>
                <el-input v-model="params.expenses" placeholder="支出单号" class="search-item"></el-input>
                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 170"
            class="finance-expense-table"
        >
            <el-table-column prop="id" label="报销单号" width="200"></el-table-column>
            <el-table-column prop="cost" label="报销金额" width="100">
                <template slot-scope="expend">{{ $tools.parsecost(expend.row.cost, true) }}</template>
            </el-table-column>

            <el-table-column prop="status" label="状态" width="120">
                <template slot-scope="expend">
                    <el-tag type="info" v-if="expend.row.status == 'WAIT_REVIEW'">待报销审核</el-tag>
                    <el-tag type="info" v-if="expend.row.status == 'WAIT'">待操作</el-tag>
                    <el-tag type="success" v-if="expend.row.status == 'WAIT_PAY'">等待打款</el-tag>
                    <el-tag type="success" v-if="expend.row.status == 'PAID'">已打款</el-tag>
                    <el-tag type="swarning" v-if="expend.row.status == 'UNPASS'">未通过</el-tag>
                    <el-tag type="danger" v-if="expend.row.status == 'INVALID'">废弃</el-tag>
               </template>
            </el-table-column>

            <el-table-column prop="creatorName" label="申请人" width="100"></el-table-column>
            <el-table-column prop="createTime" label="申请日期" width="160">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.createTime)}}</template>
            </el-table-column>

            <el-table-column prop="reviewerName" label="审核人" width="100"></el-table-column>
            <el-table-column prop="reviewTime" label="审核日期" width="160">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.reviewTime)}}</template>
            </el-table-column>

            <el-table-column prop="payerName" label="打款人" width="100"></el-table-column>
            <el-table-column prop="paymentTime" label="打款日期" width="160">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.paymentTime)}}</template>
            </el-table-column>

            <el-table-column prop="expenses" label="关联支出" width="200" :show-overflow-tooltip="true">
                <template slot-scope="expend">
                    <finance-cell-view :datas="expend.row.expenses" type="E"></finance-cell-view>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                     <el-button
                        v-if="scope.row.status == 'WAIT' || scope.row.status == 'UNPASS'"
                        type="text"
                        size="small"
                        @click="edit(scope.row.id, scope.row.expenses)"
                    > 编辑</el-button>

                    <el-button
                        v-if="scope.row.status == 'WAIT' || scope.row.status == 'UNPASS'"
                        type="text"
                        size="small"
                        @click="review(scope.row.id, 'WAIT_REVIEW', '发起')"
                    > 发起</el-button>

                    <el-button
                        v-if="scope.row.status == 'WAIT' || scope.row.status == 'UNPASS'"
                        type="text"
                        size="small"
                        @click="review(scope.row.id, 'INVALID', '废弃')"
                    > 废弃</el-button>

                    <el-button
                        v-if="scope.row.status == 'WAIT_REVIEW'"
                        type="text"
                        size="small"
                        @click="review(scope.row.id, 'WAIT', '撤回')"
                    > 撤回</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
            :page-size.sync="params.size"
        ></el-pagination>

        <el-dialog :title="accountId == null ? '新建报销单' : '修改报销单'" :visible.sync="showDialog" width="600px" @closed="closeDialog">
            <el-table
                :data="accounnts"
                stripe
                style="width: 100%"
                :height="this.$tools.mainHeight() - 450"
                class="finance-expense-table-dilaog"
            >
                <el-table-column width="33">
                    <template slot-scope="bill">
                        <el-checkbox
                            :label="bill.row.id"
                            @change="handleSelectionChange"
                            v-model="selected"
                        ></el-checkbox>
                    </template>
                </el-table-column>

                <el-table-column prop="typeName" label="支出类型" width="100"></el-table-column>

                <el-table-column prop="changed" label="支出金额" width="100">
                    <template slot-scope="bill">{{ $tools.parsecost(bill.row.cost, true)}}</template>
                </el-table-column>
                
                <el-table-column prop="expendTime" label="支出时间" width="200">
                    <template slot-scope="bill">{{ $tools.timestampToDay(bill.row.expendTime)}}</template>
                </el-table-column>

                <el-table-column prop="remark" label="备注" width="100" :show-overflow-tooltip="true"></el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="op-button" @click="showDialog=false">取消</el-button>
                <el-button type="primary" size="small" class="op-button" @click="create" v-if="accountId == null">新建报销单</el-button>
                <el-button type="primary" size="small" class="op-button" @click="create" v-if="accountId != null">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import FinanceCellView from './Finance-cell-view.vue';
export default {
    components: { FinanceCellView},
    data() {
        return {
            showDialog: false,
            params: {
                typeId: null,
                shopId: null,
                status: null,
                orderId: null,
                expendTimeStart: null,
                expendTimeEnd: null,
                current: null,
                total: null,
            },
            records: [],
            accounnts: [],
            accountId: null,
            selected: [],
            status: [
                { id: "WAIT_REVIEW", name: "待报销审核" },
                { id: "WAIT_PAY", name: "等待打款" },
                { id: "PAID", name: "已打款" },
                { id: "UNPASS", name: "未通过" },
                { id: "INVALID", name: "废弃" }
            ],
        };
    },
    methods: {
        page(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.$http.post(
                ["finance/expense/account/mypage", _this.params],
                [
                    function (data) {
                        _this.records = data.records;
                        _this.params.total = data.total;
                    },
                ],
                ".finance-expense-table"
            );
        },
        showAddDialog(expenses) {
            let _this = this;

            _this.showDialog = true;

            _this.$http.post(
                ["finance/expense/myExpensePage", {expenses: expenses}, _this.params],
                [
                    function (data) {
                        if (expenses != null) {
                            var temp = expenses.split(",");
                            
                            _this.selected = [];

                            for (var i in temp) {
                                _this.selected.push(Number.parseInt(temp[i]));
                            }
                        }

                        _this.accounnts = data.records;
                    },
                ],
                ".finance-expense-table-dilaog"
            );

        },
        closeDialog() {
            this.showDialog = false;
            this.selected = [];
        },
        edit(id, expenses) {
            let _this = this;

            _this.accountId = id;

            _this.$http.post(
                ["finance/expense/account/getExpense",{id: id}],
                [
                    function (data) {
                        _this.showAddDialog(data);
                    },
                ],
                ".finance-expense-table"
            );
        },
        review(id, type, title) {
            let _this = this;

            _this.$tConfirm.show("确认进行【" + title + "】操作？", function () {
                _this.$http.post(
                    ["finance/expense/account/save",{id: id, status: type}],
                    [
                        function (data) {
                            _this.page();
                        },
                    ],
                    ".finance-expense-table"
                );
            });
        },
        create() {
            let _this = this;

            _this.$http.post(
                ["finance/expense/account/save", {id: _this.accountId, expenses: _this.selected.join(",")}],
                [
                    function (data) {
                        _this.showDialog = false;
                        _this.page(1);
                    },
                ],
                ".finance-expense-table-dilaog"
            );
        },
        handleSelectionChange() {
            this.selectedSize = this.selected.length;
        },
    },
    mounted() {
        this.page();
    },
};
</script>

<style lang="scss">
</style>